let membership = null;

export const setMembership = (res) => { membership = res; };
export const getFirstMembership = () => membership?.MyMemberships?.[0] ?? {};
